import { Heart, PawPrint } from "lucide-react";

const TopBar = () => (
  <div className="gradient-hero">
    <div className="container flex items-center justify-center gap-2 py-2 text-sm font-medium text-primary-foreground">
      <PawPrint className="h-4 w-4" />
      <span>Cada compra ajuda animais resgatados — Paola Saldivia</span>
      <Heart className="h-3.5 w-3.5 fill-current" />
    </div>
  </div>
);

export default TopBar;
